<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <div class="card-body">
            <b-form>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="CNPJ" label-for="pes_cpfcnpjjj">
                    <input class="form-control"
                           disabled
                           v-bind:value="pessoa.pes_cpfcnpj | VMask('##.###.###/####-##')"
                           id="pes_cpfcnpjjj" type="text">
                  </b-form-group>
                </div>
                <div class="col-md-5">
                  <b-form-group label="Razão Social" label-for="pes_nome">
                    <input class="form-control"
                           maxlength="200"
                           v-model="pessoa.pes_nome"
                           :class="{ 'is-invalid': $v.pessoa.pes_nome.$error }"
                           id="pes_nome" type="text">
                    <div v-if="$v.pessoa.pes_nome.$error" class="invalid-feedback">
                      Informe a razão social
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Data de Abertura" label-for="pes_datanascimento">
                    <input v-model="pessoa.pes_datanascimento" id="pes_datanascimento"
                           :class="{ 'is-invalid': $v.pessoa.pes_datanascimento.$error }"
                           type="date" class="form-control"/>
                    <div v-if="$v.pessoa.pes_datanascimento.$error" class="invalid-feedback">
                      Informe a data de abertura
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <b-form-group label="Nome Fantasia" label-for="eco_nome_fantasia">
                    <input class="form-control"
                           maxlength="200"
                           :class="{ 'is-invalid': $v.pessoa.eco_nome_fantasia.$error }"
                           v-model="pessoa.eco_nome_fantasia" id="eco_nome_fantasia" type="text">
                    <div v-if="$v.pessoa.eco_nome_fantasia.$error" class="invalid-feedback">
                      Informe o nome fantasia
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-7">
                  <b-form-group label="Natureza Jurídica" label-for="eco_natureza_juridica">
                    <multiselect
                        v-model="pessoa.eco_natureza_juridica"
                        :class="{'is-invalid': $v.pessoa.eco_natureza_juridica.$error }"
                        placeholder="Selecione a Natureza Jurídica"
                        :custom-label="labelNaturezaJuridica"
                        track-by="naj_codigo"
                        openDirection="bottom"
                        :options="natureza_juridica"
                        :close-on-select="true"
                        :show-labels="false">
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                                    <span class="option__title">[{{
                                        props.option.naj_referencia
                                      }}] {{ props.option.naj_descricao }}</span>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="$v.pessoa.eco_natureza_juridica.$error" class="invalid-feedback">
                      Informe a natureza jurídica
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <!--
                <div class="col-md-4">
                  <b-form-group label="Tributação Especial" label-for="eco_tributacao">
                    <select id="eco_tributacao" v-model="pessoa.eco_tributacao"
                            :class="{'is-invalid': $v.pessoa.eco_tributacao.$error }"
                            class="custom-select"
                            type="text">
                      <option value="1">Microempreendedor Individual</option>
                      <option value="2">Simples Nacional</option>
                      <option value="3">Estimativo</option>
                      <option value="4">Sociedade de Profissionais</option>
                      <option value="5">Cooperativas</option>
                      <option value="6">Sem Tributação Especial</option>
                    </select>
                    <div v-if="$v.pessoa.eco_tributacao.$error" class="invalid-feedback">
                      Selecione o tipo de tributação
                    </div>
                  </b-form-group>
                </div>
                -->
                <div class="col-md-4">
                  <b-form-group label="Tipo de Estabelecimento" label-for="eco_tipo_estabelecimento">
                    <select id="eco_tipo_estabelecimento" v-model="pessoa.eco_tipo_estabelecimento"
                            class="custom-select" type="text">
                      <option value=""></option>
                      <option value="1">Matriz</option>
                      <option value="2">Filial</option>
                      <option value="3">Representação</option>
                      <option value="4">Caixa Eletrônico</option>
                      <option value="5">Torre Transmissão</option>
                      <option value="6">Depósito/Almoxarifado</option>
                      <option value="7">Garagem</option>
                      <option value="8">Posto de Coleta</option>
                      <option value="9">Ponto Quiosque/Exposição</option>
                      <option value="10">Ponto Outdoor/Publicidade</option>
                      <option value="99">Outros</option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Porte" label-for="eco_porte">
                    <select id="eco_porte" v-model="pessoa.eco_porte"
                            class="custom-select"
                            :class="{'is-invalid': $v.pessoa.eco_porte.$error }"
                            type="text">
                      <option value="1">Microempreendedor Individual (MEI)</option>
                      <option value="2">Microempresa (ME)</option>
                      <option value="3">Empresa de Pequeno Porte (EPP)</option>
                      <option value="4">Empresa de Médio Porte</option>
                      <option value="99">Demais</option>
                    </select>
                    <div v-if="$v.pessoa.eco_porte.$error" class="invalid-feedback">
                      Selecione o porte da empresa
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Tipo de Empresa" label-for="tab_103classificacao">
                    <select id="tab_103classificacao"
                            :class="{'is-invalid': $v.pessoa.tab_103classificacao.$error }"
                            v-model="pessoa.tab_103classificacao" class="custom-select" type="text">
                      <option value="923">Prestadores de Serviços</option>
                      <option value="924">Não prestadores ou Substituta Tributária</option>
                      <option value="925">Escritórios de Contabilidade</option>
                      <option value="926">Cartórios</option>
                      <option value="929">Instituições Financeiras</option>
                    </select>
                    <div v-if="$v.pessoa.tab_103classificacao.$error" class="invalid-feedback">
                      Selecione o tipo da empresa
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Inscrição Municipal" label-for="eco_inscricaomunicipal">
                    <input class="form-control"
                           maxlength="50"
                           :class="{'is-invalid': $v.pessoa.eco_inscricaomunicipal.$error }"
                           v-model="pessoa.eco_inscricaomunicipal" id="eco_inscricaomunicipal"
                           type="text">
                    <div v-if="$v.pessoa.eco_inscricaomunicipal.$error" class="invalid-feedback">
                      Informe a insc. municipal
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Inscrição Estadual" label-for="eco_inscricaoestadual">
                    <input class="form-control"
                           maxlength="50"
                           v-model="pessoa.eco_inscricaoestadual" id="eco_inscricaoestadual"
                           type="text">
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Capital Social" label-for="eco_capital_social">
                    <money class="form-control"
                           v-model="pessoa.eco_capital_social" v-bind="money"></money>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 mt-4">
                  <b-form-checkbox
                      v-model="pessoa.eco_substituicao"
                      :value="true"
                      :unchecked-value="false"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3 mt-2">
                    Empresa Substituta Tributária
                  </b-form-checkbox>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Situação da Empresa" label-for="tab_107situacao">
                    <select id="tab_107situacao" @change="alteraStatus(pessoa.tab_107situacao)"
                            v-model="pessoa.tab_107situacao"
                            class="custom-select" type="text">
                      <option value="1002">Nula</option>
                      <option value="1003">Ativa</option>
                      <option value="1004">Suspensa</option>
                      <option value="1005">Inapta</option>
                      <option value="1006">Ativa Não Regular</option>
                      <option value="1007">Baixada</option>
                    </select>
                  </b-form-group>
                </div>
                <div v-if="pessoa.tab_107situacao !== '1003'" class="col-md-4">
                  <b-form-group label="Motivo da Situação" label-for="tab_108motivo_situacao">
                    <select id="tab_108motivo_situacao"
                            :class="{'is-invalid': tab_108motivo_situacaoInvalid }"
                            v-model="pessoa.tab_108motivo_situacao"
                            class="custom-select" type="text">
                      <option v-for="t in tab_grupo_108" v-bind:key="t.tab_codigo" v-bind:value="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                    <div v-if="tab_108motivo_situacaoInvalid" class="invalid-feedback">
                      Informe um motivo para situação diferente de ativa
                    </div>
                  </b-form-group>
                </div>
              </div>
            </b-form>
            <div class="row">
              <div class="col-6">
                <b-form-group class="mt-3 text-left">
                  <button type="button"
                          @click="voltar"
                          title="Salvar dados da empresa"
                          class="btn btn-dark">
                    <i class="bx bx-arrow-back"></i> Voltar
                  </button>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group class="mt-3 text-right">
                  <button type="button"
                          @click="saveDadosEmpresa"
                          title="Salvar dados da empresa"
                          class="btn btn-success">
                    <i class="bx bx-check-double"></i> Salvar dados da empresa
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import {Money} from 'v-money'
import Multiselect from 'vue-multiselect'
import {required} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {getDadosEmpresa, putDadosEmpresa} from "@/api/admin/gestao/empresas";
import {getTabSelecoes} from "@/api/geral/helps";

const {notifySucesso, notifyErro} = require("../../../../../helps/notificacao");

export default {
  components: {
    Loader,
    Aguarde,
    Multiselect,
    Money
  },
  props: {
    eco_codigo: {
      type: Number,
      required: true
    },
    natureza_juridica: {
      type: Array,
      required: true
    },
  },
  computed: {},
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      showAguarde: false,
      httpSend: false,
      cpfCnpjInvalid: false,
      pessoa: {
        eco_codigo: null,
        pes_codigo: null,
        pes_cpfcnpj: "",
        pes_nome: "",
        eco_nome_fantasia: "",
        pes_datanascimento: null,
        eco_inscricaoestadual: "",
        eco_inscricaomunicipal: "",
        eco_porte: null,
        eco_tipo_estabelecimento: null,
        eco_natureza_juridica: null,
        eco_capital_social: 0.00,
        eco_tributacao: "",
        tab_103classificacao: null,
        eco_substituicao: false,
        tab_107situacao: '1003',
        tab_108motivo_situacao: null
      },
      tab_108motivo_situacaoInvalid: false,
      tab_grupo_108: [],
      tab_selecoes: {
        natureza_juridica: []
      },
    };
  },
  validations: {
    pessoa: {
      pes_nome: {
        required,
      },
      pes_datanascimento: {
        required,
      },
      eco_nome_fantasia: {
        required,
      },
      eco_natureza_juridica: {
        required,
      },
      eco_inscricaomunicipal: {
        required,
      },
      eco_tributacao: {
        required,
      },
      eco_porte: {
        required
      },
      tab_103classificacao: {
        required,
      }
    }
  },
  created() {
    this.getDados();
  },
  methods: {
    labelNaturezaJuridica({naj_referencia, naj_descricao}) {
      return `[${naj_referencia}] ${naj_descricao}`
    },
    alteraStatus(tab_107situacao) {
      this.getTabGrupo108();
      const new_tab_107situacao = parseInt(tab_107situacao)
      if (new_tab_107situacao === 1003) {
        Swal.fire({
          title: "Termo de responsabilidade",
          html: 'Declaro que as pendência que motivaram a suspensão deste econômico foram plenamente sanadas e que a empresa está apta a emitir documentos fiscais de serviço.',
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Ciente",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (!result.isConfirmed) {
            this.getDados()
          }
        });
      }
    },
    getDados() {
      this.httpSend = true;
      getDadosEmpresa(this.eco_codigo).then(result => {
        if (result.status) {
          this.pessoa = result.dados;
          this.pessoa.eco_substituicao = (this.pessoa.eco_substituicao === 'S');
          this.getTabGrupo108();
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveDadosEmpresa() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.tab_108motivo_situacaoInvalid = false;
      if (this.pessoa.tab_107situacao !== '1003') {
        if (!this.pessoa.tab_108motivo_situacao) {
          this.tab_108motivo_situacaoInvalid = true;
          return false;
        }
      }
      this.showAguarde = true;
      putDadosEmpresa(this.eco_codigo, this.pessoa).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    getTabGrupo108() {
      if (this.pessoa.tab_108motivo_situacao === '1003') {
        return
      }
      if (this.tab_grupo_108.length > 0) {
        return;
      }
      getTabSelecoes(108).then(result => {
        if (result.status) {
          this.tab_grupo_108 = result.dados.grupo108;
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    voltar() {
      this.$router.back();
    }
  }
};
</script>
